/* Shared primitives. Kept tiny and dependency-free so every other module can
   import it without creating a cycle. */

/* Bumped on every change so a stale CDN cache stays diagnosable (see CLAUDE.md).
   Vite injects the build flavour; the -prod suffix is what the deploy guard greps for. */
export const BUILD_ID = __BUILD_ID__;

export const $ = (id: string): any => document.getElementById(id);

export const fmt = (n: number): string =>
  n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/* True only in the demo build. Vite replaces this with a literal at build time,
   so the production bundle tree-shakes every outcome-override path away
   entirely — the code cannot be reached, because it is not shipped. */
export const IS_DEMO_BUILD: boolean = __IS_DEMO_BUILD__;
